var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"cont"}},[_c('NewAbout'),_c('div',{attrs:{"id":"page"}},[_c('Experience'),_c('Skills')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }